module.exports = __webpack_public_path__ + "static/aot-0f92cf0425a90260db5ab5643e649d38.jpg";